import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AccountGroupService } from '@galaxy/account-group';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyAddressPipe } from '@vendasta/galaxy/pipes';
import { GalaxyStatisticModule } from '@vendasta/galaxy/statistic';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { VaBadgeModule, VaCardsModule } from '@vendasta/uikit';
import { Filter2TableModule } from '@vendasta/va-filter2-table';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { SalespersonSelectorDialogModule } from '../salesperson-selector-dialog/salesperson-selector-dialog.module';
import { SalesOrderActionsCellComponent } from './cells/sales-order-actions-cell.component';
import { BusinessInfoCellComponent } from './cells/business-info-cell.component';
import { DateCellComponent } from './cells/date-cell.component';
import { ExpiryCellComponent } from './cells/expiry-cell.component';
import { OrderIdCellComponent } from './cells/order-id-cell.component';
import { OrderTagsCellComponent } from './cells/order-tags-cell.component';
import { SalesOrderTableCustomComponentDirective } from './cells/sales-order-table-custom.component';
import { SalespersonCellComponent } from './cells/salesperson-cell.component';
import { StatusCellComponent } from './cells/status-cell.component';
import { SalesOrdersTableComponent } from './sales-orders-table.component';
import { FulfillmentCellComponent } from './cells/fulfillment-cell.component';
import { SalesOrderTableStatsComponent } from './sales-order-table-stats/sales-order-table-stats.component';

@NgModule({
  declarations: [
    SalesOrdersTableComponent,
    BusinessInfoCellComponent,
    OrderIdCellComponent,
    OrderTagsCellComponent,
    SalespersonCellComponent,
    DateCellComponent,
    StatusCellComponent,
    FulfillmentCellComponent,
    ExpiryCellComponent,
    SalesOrderActionsCellComponent,
    SalespersonCellComponent,
    SalesOrderTableCustomComponentDirective,
    SalesOrderTableStatsComponent,
  ],
  imports: [
    CommonModule,
    Filter2TableModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    VaBadgeModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    VaCardsModule,
    GalaxyStatisticModule,
    GalaxyBadgeModule,
    SalespersonSelectorDialogModule,
  ],
  providers: [
    AccountGroupService,
    GalaxyAddressPipe,
    { provide: MAT_DATE_LOCALE, useValue: getLocale() },
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    { provide: 'FULFILLMENT_CELL_LINK_VERSION', useValue: false },
  ],
  exports: [SalesOrdersTableComponent, SalesOrderTableStatsComponent],
})
export class SalesOrdersTableModule {}
